export enum STORAGE_KEYS {
  ActiveToken = 'quickshareActiveToken',
  ProfilesData = 'quickshareProfilesData',
}
